export default function isEmpty(value: any) {
  return (
    value == null ||
    typeof value === undefined ||
    value.length === 0 ||
    value === 'undefined'
  );
}
